<template>
  <v-main>

    <v-container
        id="payments-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-bank-check"
          class="px-5 py-5"
      >

        <shared-page-messages :error-messages="errorMessages"
                              :warning-messages="warningMessages"
                              :success-messages="successMessages">
        </shared-page-messages>

        <v-row align="center">
            <v-col
                cols="6"
                lg="2"
                sm="3"
            >
              <v-select
                  v-model="bulkActionStatus"
                  :items="computedPaymentStatusItems"
                  item-text="text"
                  item-value="value"
                  label="Bulk Status"
                  return-object
                  dense
                  hint="Apply to selected payments"
                  persistent-hint
              ></v-select>
            </v-col>

            <v-col
                cols="3"
                sm="3"
                lg="2"
            >
              <v-btn
                  small
                  color="primary"
                  @click="handleBulkActionForm"
              >
                Submit
              </v-btn>
            </v-col>
            <v-col
                cols="3"
                lg="8"
                sm="6"
                align="right"
            >

              <v-dialog
                v-model="filtersDialog"
                max-width="400"
              >

                <template v-slot:activator="{ on, attrs }">

                  <v-btn
                      small
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon size="small">mdi-filter</v-icon> Filters
                    </v-btn>
                </template>

                <v-card>
                  <v-card-title class="text-h5 text-left">
                    Payment Filters
                  </v-card-title>

                  <v-card-text>

                    <v-form ref="paymentFiltersForm"
                            @submit.prevent="applyFilters">

                    <v-row dense>
                      <v-col
                        cols="12"
                        sm="12"
                      >
                       <v-select
                           v-model="filter.paymentStatuses"
                           :items="computedPaymentStatusItems"
                           label="Payment Status"
                           item-text="text"
                           item-value="value"
                           dense
                           multiple
                       ></v-select>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col
                          cols="12"
                          sm="12"
                      >
                        <v-text-field
                            v-model="filter.paymentReferenceNumber"
                            label="Reference Number"
                            dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col
                          cols="12"
                          sm="12"
                      >
                        <v-text-field
                            v-model="filter.firstName"
                            label="First Name"
                            dense
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col
                          cols="12"
                          sm="12"
                      >
                        <v-text-field
                            v-model="filter.lastName"
                            label="Last Name"
                            dense
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col
                          cols="12"
                          sm="12"
                      >
                        <v-select
                            v-model="filter.paymentMethod"
                            :items="computedPaymentMethodItems"
                            label="Payment Method"
                            item-text="text"
                            item-value="value"
                            dense
                        ></v-select>

                      </v-col>
                    </v-row>

                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        color="primary"
                        @click="filtersDialog = false"
                    >
                      Close
                    </v-btn>
                    <v-btn
                        small
                        color="primary"
                        @click="applyFilters"
                    >
                      Apply
                    </v-btn>
                  </v-card-actions>

                </v-card>

              </v-dialog>
            </v-col>
          </v-row>

          <v-simple-table v-if="computedPaymentsList" class="pt-5"
            dense
          >
            <template v-slot:default>
              <thead>
              <tr>
                <th class="payment-action">
                  <v-checkbox
                      v-model="computedSelectAll"
                      hide-details
                      class="shrink ma-0 pa-0"
                  />
                </th>
                <th class="payment-inv-num text-subtitle-2">Inv #</th>
                <th class="payment-date text-subtitle-2">Date</th>
                <th class="payment-from text-subtitle-2">From</th>
                <th class="payment-claim text-subtitle-2">Replenishment/Details</th>
                <th class="payment-amount text-right text-subtitle-2">Amount</th>
                <th class="payment-method text-subtitle-2">Method</th>
                <th class="payment-reference text-subtitle-2">Ref. #</th>
                <th class="payment-status text-subtitle-2">Status</th>
              </tr>
              </thead>

              <tbody>
              <tr
                  v-for="payment in computedPaymentsList"
                  :key="payment.id"
              >
                <td>
                  <v-checkbox
                      v-model="bulkActionItems"
                      :value="payment.id"
                      hide-details
                      class="shrink ma-0 pa-0"
                  />
                </td>
                <td>
                  <router-link :to="{ name: 'view_invoice', params: {invoiceId: payment.invoiceNumber} }">
                    {{ payment.invoiceNumber }}
                  </router-link>
                </td>
                <td>{{ payment.date | formatLocalDate }} </td>
                <td>
                  {{ payment.from }}
                </td>
                <td>
                  {{ payment.items }}
                </td>
                <td class="text-right"> {{ payment.amount | formatCurrency }} </td>
                <td> {{ paymentMethodMap[payment.method] }} </td>
                <td>
                  <router-link :to="{ name: 'add_edit_payment', params: {invoiceId: payment.invoiceNumber, paymentId: payment.id} }">
                    ...{{ payment.reference.slice(-8) }}
                  </router-link>
                </td>
                <td>{{ payment.status }}</td>
              </tr>
              </tbody>

            </template>
          </v-simple-table>

        <div class="text-center mt-3">
          <v-pagination
              v-model="filter.page"
              :length="searchResponse.page.totalPages || 1"
              :total-visible="8"
              @input="fetchInvoices"
          ></v-pagination>
        </div>


      </base-material-card>


    </v-container>

  </v-main>
</template>

<script>
import api from '@/services/api'
import constants from '@/utils/constants'
import SharedPageMessages from '../shared/PageMessages.vue'

export default {
  name: 'CorePaymentsView',
  components: { SharedPageMessages },

  created: async function () {
    await this.fetchInvoices()
  },

  props: [
      'paymentStatuses'
  ],

  computed: {
    computedPaymentsList: function () {
      return this.searchResponse.content.flatMap(inv => {
        return inv.payments.map(pmt => {
          const row = {
            id: pmt.id,
            invoiceNumber: inv.id,
            from: inv.user.names,
            items: inv.items.map(item => item.description).join(', '),
            amount: pmt.amount,
            date: pmt.date,
            method: pmt.method,
            bankBranch: pmt.bankDepositBranch,
            reference: pmt.reference,
            status: this.paymentStatusMap[pmt.status],
            isVerified: pmt.status === constants.PAYMENT_STATUS_VERIFIED,
          }

          if (inv.claim != null) {
            row.claimUser = inv.claim.user.names
          }

          return row
        })
      })
    },

    computedSelectAll: {
      set: function (value) {
        if (value === true) {
          this.computedPaymentsList.forEach(payment => {
            this.bulkActionItems.push(payment.id)
          })
        }
      },
      get: function () {
        return this.computedPaymentsList.length > 0 && this.computedPaymentsList.length === this.bulkActionItems.length
      }
    },

    computedPaymentStatusItems: {
      get: function () {
        return Object.keys(this.paymentStatusMap)
            .map((key) => ({value: key, text: this.paymentStatusMap[key]}))
      }
    },

    computedPaymentMethodItems: {
      get: function () {
        return Object.keys(this.paymentMethodMap)
            .map((key) => ({value: key, text: this.paymentMethodMap[key]}))
      }
    }
  },

  watch: {
    searchResponse: function (val) {
      if (val.empty) {
        this.warningMessages.push("No payments matching your filter criteria could be found. Please adjust your filters.")
      }
    },
    errorMessages: function (val) {
      if (val.length > 0) {
        scroll(0, 0)
      }
    },
    successMessages: function (val) {
      if (val.length > 0) {
        scroll(0, 0)
      }
    },
    warningMessages: function (val) {
      if (val.length > 0) {
        scroll(0, 0)
      }
    }
  },

  methods: {
    clearMessages: function() {
      this.errorMessages = []
      this.successMessages = []
      this.warningMessages = []
    },

    handleBulkActionForm: function () {
      this.clearMessages()
      this.successMessages = []
      if (this.bulkActionStatus === null) {
        this.errorMessages.push('Please select a bulk status')
      }

      if (this.bulkActionItems.length === 0) {
        this.errorMessages.push('Please select at least one payment')
      }

      if (this.errorMessages.length === 0) {
        this.processBulkAction()
      }
    },

    applyFilters: function () {
      this.filtersDialog = false
      this.clearMessages()
      this.fetchInvoices()
    },

    fetchInvoices: async function () {
      this.clearMessages()
      let filterParams = {
        paymentReferenceNumber: this.filter.paymentReferenceNumber,
        paymentStatuses: this.filter.paymentStatuses.join(','),
        paymentMethods: this.filter.paymentMethod,
        firstName: this.filter.firstName,
        lastName: this.filter.lastName,
        limit: this.filter.itemsPerPage,
        page: this.filter.page,
      }

      return api.fetchInvoices(filterParams)
          .then(response => {
            this.searchResponse = response.data
          })
          .catch(err => {
            this.handleError(err)
          })
    },

    handleError: function (err) {
      let errorMessage = api.parseResponseError(err, true)
      this.errorMessages.push(errorMessage)
    },

    processBulkAction: async function () {
      let payload = {
        status: this.bulkActionStatus.value,
        ids: this.bulkActionItems
      }

      return api.updateBulkPaymentStatuses(payload)
          .then(response => {
            this.bulkActionItems = []
            this.bulkActionStatus = null
            this.successMessages.push('Payments statuses updated successfully.')
            this.fetchInvoices()
          })
          .catch(err => {
            this.handleError(err)
          })
    }
  },

  data() {
    return {
      invoices: [],
      errorMessages: [],
      warningMessages: [],
      successMessages: [],
      bulkActionStatus: null,
      bulkActionItems: [],
      bulkActionValid: false,
      filterPaymentStatus: null,
      filtersDialog: false,
      filter: {
        paymentStatuses: this.paymentStatuses,
        page: 1,
        itemsPerPage: 25,
      },
      searchResponse: {
        content: [],
        empty: true,
        page: {
          totalPages: 0,
        }
      },
      paymentMethodMap: constants.getPaymentMethodMap(),
      paymentStatusMap: constants.getPaymentStatusMap(),
    }
  }
}
</script>


<style lang="sass">
th.incident-date
  width: 10%

th.relationship-type, th.payment-action
  width: 5%

tr.highlight-new-payment
  background-color: #F1F8E9

th.payment-date, th.payment-method, th.payment-reference, th.payment-amount
  width: 10%

</style>
